<div class="modal-wrapper" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
  <div class="modal-content">
    <div class="modal-header">
      <h2>Create New Account</h2>
      <div class="bar"></div>

      <button class="close-wrapper" (click)="close(undefined)" aria-label="Close modal">
        <div class="icon" [innerHTML]="closeIcon"></div>
      </button>
    </div>

    <div class="modal-body">
      @for (configItem of configItems; track configItem) {
        <div>
          <lib-editor-item [configItem]="configItem" [factory]="factory" #editorItem></lib-editor-item>
        </div>
      }
    </div>

    <div class="modal-footer">
      <button class="modal-button cancel" (click)="close(undefined)" [disabled]="isLoading">Cancel</button>
      <app-loading-button [isLoading]="isLoading" (clickEvent)="saveAccount()" text="Create"></app-loading-button>
    </div>
  </div>
</div>
